import posthog from "posthog-js";
import {router} from "@inertiajs/vue3";

const enabled = () => import.meta.env.PROD && !import.meta.env.SSR;

let identifiedId = null;

// Keep the PostHog person in sync with the logged-in user so frontend and
// backend events (which use the user id as distinct id) land on one person.
const syncIdentity = (page) => {
    const user = page?.props?.auth?.user;
    if (user?.id) {
        const id = String(user.id);
        if (identifiedId !== id) {
            posthog.identify(id, {email: user.email, name: user.name});
            identifiedId = id;
        }
    } else if (identifiedId) {
        posthog.reset();
        identifiedId = null;
    }
};

export default {
    install(app) {
        if (!enabled()) {
            return;
        }

        app.config.globalProperties.$posthog = posthog.init(
            'phc_EjFYl0bhlIXvEhguLqwPtW2lXuUAF02uwdhxf2UJ8KN',
            {
                api_host: 'https://us.i.posthog.com',
                capture_pageview: false,
            }
        );

        // Inertia fires `navigate` for the initial page and every client-side
        // visit, so this covers all pageviews (the default only saw the first).
        router.on('navigate', (event) => {
            syncIdentity(event.detail.page);
            posthog.capture('$pageview');
        });
    },
};
